




















































































import { Component, Vue } from "vue-property-decorator";
import requests, {
  LearningRequestsListParams
} from "@/getinfo-api/learning-requests";
import { getCurrentCompanyId } from "@/plugins/roles";
import { LearningRequestShort as ILearningRequestShort } from "@/api/models/learning-request-short";
import { groupBy } from "lodash";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import moment from "moment";

@Component({
  components: { CustomDatepicker }
})
export default class StatisticByRequests extends Vue {
  isLoading: boolean = false;
  requests?: Array<ILearningRequestShort> = [];
  formedAtMin?: Date = new Date(
    moment()
      .startOf("month")
      .format()
  );
  formedAtMax?: Date;

  data() {
    return {
      formedAtMax: undefined
    };
  }

  get companyId() {
    return getCurrentCompanyId();
  }

  get courses() {
    const _courses = this.requests?.filter(_ => _.resourceType === "course");
    const grouped = groupBy(_courses, "resourceTitle");
    return new Map(this.sortedByLength(grouped));
  }

  get contractors() {
    const grouped = groupBy(this.requests, "contractor.fullName");
    return new Map(this.sortedByLength(grouped));
  }

  get contractorsCount() {
    return this.contractors?.size;
  }

  get coursesCount() {
    return this.courses?.size;
  }

  sortedByLength(groupedObject: object) {
    let newArray = Object.entries(groupedObject);
    let map = new Map(newArray);
    const unsortedArray = [...map];
    return unsortedArray.sort(
      ([key, value1], [key2, value2]) => value2.length - value1.length
    );
  }

  async getRequests() {
    try {
      this.isLoading = true;
      const params: LearningRequestsListParams = {
        companyId: this.companyId,
        formedAtMin: this.formedAtMin ? this.formedAtMin : undefined,
        formedAtMax: this.formedAtMax ? this.formedAtMax : undefined,
        limit: 900,
        offset: 0
      };
      const { data } = await requests(params);
      this.requests = data.requests;
    } finally {
      this.isLoading = false;
    }
  }

  get screenWidth() {
    return window.innerWidth;
  }

  textShort(a: any) {
    if (this.screenWidth < 576) {
      return a.slice(0, 15) + "...";
    }
    return a.slice(0, 30) + "...";
  }

  created() {
    this.formedAtMin = undefined;
    this.formedAtMax = new Date();
    if (this.companyId) {
      this.getRequests();
    }
  }
}
